import { Component, OnDestroy } from '@angular/core';
import {User} from '../../../@core/models';
import {
  NbMediaBreakpoint,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
} from '@nebular/theme';
import { Router } from '@angular/router';

import { StateService } from '../../../@core/data/state.service';

import { Subscription, Subject, timer } from 'rxjs';

import { environment } from 'environments/environment';

import { delay, withLatestFrom, switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ngx-sample-layout',
  styleUrls: ['./sample.layout.scss'],
  template: `
    <nb-layout [center]="layout.id === 'center-column'" windowMode>
      <nb-layout-header style="background: #EBEFF5; position:fixed; z-index: 1050; width: 100%; top: 0; left:0">
          <ngx-header (changeToFullScreenOnTopbar)="setFullScreenMode($event)" *ngIf="!isMaximized && !hideLayout" [position]="sidebar.id === 'left' ? 'normal': 'inverse'"></ngx-header>
      </nb-layout-header>

      <nb-sidebar *ngIf="!isMaximized && !hideLayout" class="menu-sidebar"
                   tag="menu-sidebar"
                   responsive
                   state="compacted"
                   [right]="sidebar.id === 'right'"
                   (mouseenter)="onMouseOver()"
                   (mouseleave)="onMouseOut()">
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>
      
      <nb-layout-column class="main-content" >
        <div *ngIf="isMaximized && !hideLayout" class="full-screen-collapsed-menu d-flex justify-content-center" [ngClass]="{'full-screen-expanded-menu' : !isCollapsed}">
          <div class="toggle-full-screen-menu d-flex justify-content-center align-items-start"  (click)="expandMenu(isCollapsed)">
            <div *ngIf="!isCollapsed" class="option-control">
              <button class="minimize-screen-button mt-3" (click)="maximizeScreen()" pTooltip="{{ 'GLOBAL.restore' | translate }}" tooltipPosition="bottom">
                <img src="./assets/minimize_full_screen_icon.svg">
              </button>
              <img src="./assets/collapse_fullscreen_menu_icon.svg">
            </div>
              <img *ngIf="isCollapsed" src="./assets/expand_fullscreen_menu_icon.svg">
          </div>
        </div>
        
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-column left class="small" *ngIf="layout.id === 'two-column' || layout.id === 'three-column'">
        <nb-menu [items]="subMenu"></nb-menu>
      </nb-layout-column>

      <nb-layout-column right class="small" *ngIf="layout.id === 'three-column'">
        <nb-menu [items]="subMenu"></nb-menu>
      </nb-layout-column>

      <nb-layout-footer *ngIf="!isMaximized && !hideLayout" fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>

      <nb-sidebar class="settings-sidebar"
                   tag="settings-sidebar"
                   state="collapsed"
                   fixed
                   [right]="sidebar.id !== 'right'">
        <ngx-theme-switcher></ngx-theme-switcher>
        <ngx-theme-settings></ngx-theme-settings>
      </nb-sidebar>
    </nb-layout>
  `,
})
export class SampleLayoutComponent  implements OnDestroy {

  subMenu: NbMenuItem[] = [
    {
      title: 'PAGE LEVEL MENU',
      group: true,
    },
    {
      title: 'Buttons',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/buttons',
    },
    {
      title: 'Grid',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/grid',
    },
    {
      title: 'Icons',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/icons',
    },
    {
      title: 'Modals',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/modals',
    },
    {
      title: 'Typography',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/typography',
    },
    {
      title: 'Animated Searches',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/search-fields',
    },
    {
      title: 'Tabs',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/tabs',
    },
  ];
  layout: any = {};
  sidebar: any = {};
  logoPicture: string;
  isMaximized: boolean = false
  isCollapsed: boolean = true
  sidebarCloseCancelled: boolean = false
  sidebarIsExpanded: boolean = false
  closingSidebarInProgress: boolean = false
  mouseOverTimeoutEnd: boolean = false
  mouseOverSub: Subscription
  mouseOutSub: Subscription
  private mouseOver$ = new Subject<void>();
  private mouseOut$ = new Subject<void>();
  private elementsWithClasses: { element: HTMLElement, classes: string[] }[] = [];
  protected layoutState$: Subscription;
  protected sidebarState$: Subscription;
  protected menuClick$: Subscription;
  public hideLayout: boolean = environment.hideLayout !=null? environment.hideLayout : false;
  public ignorePasswordReset: boolean = environment.ignorePasswordReset != null ? environment.ignorePasswordReset : false;

  constructor(private router: Router,
              protected stateService: StateService,
              protected menuService: NbMenuService,
              protected themeService: NbThemeService,
              protected bpService: NbMediaBreakpointsService,
              protected sidebarService: NbSidebarService) {
    this.layoutState$ = this.stateService.onLayoutState()
      .subscribe((layout: string) => this.layout = layout);

    this.sidebarState$ = this.stateService.onSidebarState()
      .subscribe((sidebar: string) => {
        this.sidebar = sidebar
      });

      this.mouseOverSub = this.mouseOver$.pipe(
        switchMap(() => {
          return timer(400).pipe(
            takeUntil(this.mouseOut$)
          );
        })
      ).subscribe(() => {
        if (!this.sidebarIsExpanded && !this.closingSidebarInProgress) {
          this.sidebarService.expand('menu-sidebar');
          this.sidebarIsExpanded = true;
        }
      });
  
      this.mouseOutSub = this.mouseOut$.pipe(
        switchMap(() => {
          return timer(300).pipe(
            takeUntil(this.mouseOver$)
          );
        })
      ).subscribe(() => {
        if (this.sidebarIsExpanded && !this.sidebarCloseCancelled && !this.closingSidebarInProgress) {
          this.closingSidebarInProgress = true;
          this.sidebarService.toggle(true, 'menu-sidebar');
          this.sidebarIsExpanded = false;
          setTimeout(() => {
            this.closingSidebarInProgress = false;
            if (this.mouseOverTimeoutEnd) {
              this.sidebarService.expand('menu-sidebar');
              this.sidebarIsExpanded = true;
            }
          }, 800)
        }
      });
    
    

    const isBp = this.bpService.getByName('is');
    this.menuClick$ = this.menuService.onItemSelect()
      .pipe(
        withLatestFrom(this.themeService.onMediaQueryChange()),
        delay(20),
      )
      .subscribe(([item, [bpFrom, bpTo]]: [any, [NbMediaBreakpoint, NbMediaBreakpoint]]) => {
        if(JSON.parse(window.localStorage.getItem('currentUser')).isMustChangePassword && !this.ignorePasswordReset){
          this.router.navigateByUrl('/pages/user-change-password');
        }
      });
  }

  ngOnInit() {
    if(JSON.parse(window.localStorage.getItem('currentUser')).isMustChangePassword && !this.ignorePasswordReset){
      this.router.navigateByUrl('/pages/user-change-password');
    }
  }
  ngOnDestroy() {
    this.layoutState$.unsubscribe();
    this.sidebarState$.unsubscribe();
    this.menuClick$.unsubscribe();
    this.mouseOverSub.unsubscribe();
    this.mouseOutSub.unsubscribe();
  }

  onMouseOver() {
    this.sidebarCloseCancelled = true
    this.mouseOver$.next()
    this.mouseOverTimeoutEnd = true
}

onMouseOut() {
  this.sidebarCloseCancelled = false
  this.mouseOut$.next()
  this.mouseOverTimeoutEnd = false
}

  setFullScreenMode(fullScreen) {
    if(fullScreen) this.maximizeScreen()
  }

  expandMenu(isCollapsed) {
    this.isCollapsed = !isCollapsed
  }  

  maximizeScreen() {
    this.isMaximized = !this.isMaximized;
  
    if (this.isMaximized) {
      this.removeClassesFromElements(['padding-default', 'padding-default-card', 'padding-default-table', 'padding-default-wrapper']);
      this.isCollapsed = true
    } else {
      this.restoreClassesToElements();
    }
  }

  public userProfile() {
    let user: User = JSON.parse(window.localStorage.getItem('currentUser'));     
    if (user) {
      this.logoPicture = user.picture;  
    }
  }

  removeClassesFromElements(classNames: string[]) {
    const selectors = classNames.map(className => `.${className}`).join(',');
    const elementsWithClasses = document.querySelectorAll(selectors);

    this.elementsWithClasses = [];
  
    Array.from(elementsWithClasses).forEach((element: HTMLElement) => {
    
      const classesToRemove = classNames.filter(className => element.classList.contains(className));
      this.elementsWithClasses.push({ element, classes: classesToRemove });

      classesToRemove.forEach(className => element.classList.remove(className));
    });
  }

  restoreClassesToElements() {

    this.elementsWithClasses.forEach(({ element, classes }) => {
      classes.forEach(className => element.classList.add(className));
    });

    this.elementsWithClasses = [];
  }
}
